import { Component, OnInit, OnDestroy } from '@angular/core';

import { CommunicationService } from 'src/app/shared/services/communication.service';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-sidebar-nav',
  templateUrl: './sidebar-nav.component.html',
  styleUrls: ['./sidebar-nav.component.css']
})
export class SidebarNavComponent implements OnInit, OnDestroy {
  sidebarMinimized = false;
  sidebarSubscription = new Subscription();

  constructor(
    private authService: AuthService,
    private communicationService: CommunicationService,
  ) { }

  ngOnInit() {
    this.changeSideBarStatus();
  }

  changeSideBarStatus() {
    this.sidebarSubscription = this.communicationService.getSideBarStatus().subscribe(status => {
      this.sidebarMinimized = status;
    });
  }

  ngOnDestroy() {
    this.sidebarSubscription.unsubscribe();
  }

  logout() {
    this.authService.logout()
  }

}
